export enum StatusMeta {
  PartlySuccess = -1,
  Success = 0,
  Pending = 1,
  Failure = 2,
  SpecialError = 3,
}
